import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import CustomTooltip from '../CustomTooltip';

export default function PushNoticeCard({ icon, bgColor, title, subtitle }) {
    return (
        <Row>
            <Col md={12}>
                <Card className="push-card">
                    <Row>
                        <Col xs={3} md={3}
                            className="icon-section text-center d-flex justify-content-center"
                            style={{ backgroundColor: bgColor }}
                        >
                            {icon}
                        </Col>
                        <Col xs={9} md={9} className="p-0">
                            <div className="px-3">
                                <button type="button" className="text-decoration-none btn btn-link p-0">
                                    <p className="mb-0 dashTitle">{title}</p>
                                </button>

                                <div className="d-flex pb-3 justify-content-between align-items-center">
                                    <p className="dashSubTitle mb-0">{subtitle}</p>
                                    <CustomTooltip title="Updated in real-time">
                                        <i className="fa fa-exclamation-circle pe-2 infoicon" aria-hidden="true"></i>
                                    </CustomTooltip>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    );
}
